import { Messages } from '../../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../../settings/services/ServerSettingsUnauthenticated';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { siteUserEditAuthentication } from '../../../actions/spaces/SiteUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectSiteUserGuest } from './IEntityActionHelpers';

export const SiteUserSetAuthenticationAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserAuthentication,
  translateName: Messages.authentication_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return ServerSettingsUnauthenticated.isSiteSamlEnabled();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectSiteUserGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditAuthentication(targetItems)
};
